import { getData } from "../Services/getData";
import { endpoints } from "./UrlEnum";

/**
 * Fetches document types from the API where isTemplate=true
 * @returns Promise<any[]>
 */
export const fetchDocumentTypes = async (): Promise<any[]> => {
  try {
    const response = await getData(endpoints.documentTypes);
    if (response?.data) {
      return response.data.filter((docType: any) => docType.isTemplate === true);
    }
    return [];
  } catch (error) {
    console.error("Error fetching document types:", error);
    return [];
  }
};